import './assets/scss/main.scss'
import 'bootstrap';
import '@popperjs/core';
import jQuery from 'jquery';

// Make jQuery available globally for WebRotate360
window.jQuery = jQuery;
window.$ = jQuery;

// Load WebRotate360 script after jQuery is available
const script = document.createElement('script');
script.src = '/webrotate360/js/imagerotator.js';
script.async = false; // Ensure it loads before Vue components
document.head.appendChild(script);

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import VueSplide from '@splidejs/vue-splide'
import '@splidejs/vue-splide/css/core';

import Swal from 'sweetalert2';

import axiosPlugin from './plugins/axios'

const app = createApp(App);

import bus from './bus';

app.config.globalProperties.$bus = bus;

app.config.globalProperties.$swal = Swal;

store.dispatch('account/initializeSession');

axiosPlugin(router);  // Apply plugin to global axios instance

app.use(router);
app.use(store);
app.use(VueSplide);

if (typeof window !== 'undefined' && !document.getElementById('hs-script-loader')) {
    const script = document.createElement('script')
    script.id = 'hs-script-loader'
    script.src = '//js-eu1.hs-scripts.com/145611921.js'
    script.async = true
    script.defer = true
    document.head.appendChild(script)
}

app.mount('#app');
